module.exports = __webpack_public_path__ + "media/application/images/news/secondary_nav/recent-942eb80964430605994ae8b06411e164.jpg";